import { DynamicInputFormType, InputTypes } from "../../../../../Components";

export const NearPointConvergenceConfig: {
  type: string;
  title: string;
  fields: DynamicInputFormType[];
} = {
  type: "Near Point Convergence",
  title: "Near Point Convergence",
  fields: [
    {
      dataType: InputTypes.Date,
      accessor: "Date",
      Header: "Date",
    },
    {
      dataType: InputTypes.Number,
      accessor: "Break",
      Header: "Break",
    },
    {
      dataType: InputTypes.Number,
      accessor: "Recovery",
      Header: "Recovery",
    },
  ],
};
